<template>
<div>
  <v-row>
    <!-- <v-col cols="8">
      <h1> 培訓隊申請</h1>
    </v-col>  -->
    <v-col cols="12" class="d-flex justify-end">
      <div class="d-inline-block" v-if="tbtca15Vo.deptNo==userDataCookie.depNo">
        <VBtn class="mr-2" color="primary" variant="tonal"
        @click="save" 
        :loading="loadingBtn"
        v-if="Object.keys(viewParams.actionBtn).length === 0 || (!viewParams.actionBtn.action_revoke && (viewParams.actionBtn.action_approve || viewParams.actionBtn.action_start) ) "
        :disabled="!tbtca15Vo.projectId || !tbtca15Vo.stage">
          儲存
        </VBtn>
        <VBtn class="mr-2" variant="tonal" color="error" 
        @click="deleteForm" 
        :loading="loadingBtn"
        v-if="tbtca15Vo.applyNo && userDataCookie.userno==tbtca15Vo.createEmpNo&&(tbtca15Vo.status === 'Draft' || (Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_delete && tbtca15Vo.status !== 'ReturnedForRevision'))">
          刪除
        </VBtn>
        <VBtn class="mr-2" variant="tonal" color="success" 
        @click="submit"
        :loading="loadingBtn"
        v-if="isAssociationContact(userDataCookie, submissionAsContact)&&((Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_start)||tbtca15Vo.status === 'Draft')">
          送出
        </VBtn>
      </div>
      <VBtn class="mr-2" variant="tonal" color="error" 
      :loading="loadingBtn"
      @click="withdraw" v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_revoke && tbtca15Vo.status === 'Submitted'">
        收回
      </VBtn>
      <VBtn class="mr-2" variant="tonal" color="primary" 
      :loading="loadingBtn"
      @click="firstrev" v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve && tbtca15Vo.status === 'Submitted'">
        提交會議審議
      </VBtn>
      <VBtn class="mr-2" variant="tonal" color="primary" @click="approve"  
      :loading="loadingBtn"
      v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve && (tbtca15Vo.status === 'Passed'||tbtca15Vo.status === 'Resubmitted')">
        備查
      </VBtn>
      <VBtn class="mr-2" variant="tonal" color="warning" 
      :loading="loadingBtn"
      @click="revise" v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve && (tbtca15Vo.status === 'Passed'||tbtca15Vo.status === 'Resubmitted')">
        回覆修正
      </VBtn>
      <VBtn class="mr-2" variant="tonal" color="error" 
      :loading="loadingBtn"
      @click="reject" v-if="Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve && (tbtca15Vo.status === 'Submitted'||tbtca15Vo.status === 'Passed')">
        駁回
      </VBtn>
      <VBtn class="mr-2" variant="tonal" color="primary" @click="training"  
      :loading="loadingBtn"
      v-if="tbtca15Vo.status === 'Approved'">
        已調訓
      </VBtn>
      <!-- <VBtn variant="outlined" color="secondary" @click="getFile">test</VBtn> -->
      
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="8">
      <VCard height="100%">
        <VCardText>
          <!-- {{viewParams}} -->
          <v-row>
            <v-col cols="6">
              <v-select label="計畫項目"
                item-title="1"
                item-value="0"
                @update:model-value="changeProjectSelect"
                v-model="tbtca15Vo.projectId"
                :items="viewParams.projectSelect" ></v-select>

            </v-col>
            <v-col cols="6">
              <v-select label="培訓階段"
                item-title="1"
                item-value="0"
                v-model="tbtca15Vo.stage"
                no-data-text="尚無資料"
                :items="viewParams.stageSelect" ></v-select>
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col cols="6">
              <div class="text-subtitle-1 mb-2">培訓計畫</div>
              <v-btn  v-if="viewParams.trainingPlanFileUrl" @click="getJwtBeforeRedirect(viewParams.trainingPlanFileUrl)">培訓計畫下載</v-btn>
            </v-col>
            <v-col cols="6">
              <div class="text-subtitle-1 mb-2">遴選辦法</div>
               <v-btn v-if="viewParams.selectionFileUrl" @click="getJwtBeforeRedirect(viewParams.selectionFileUrl)">遴選辦法下載</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-2 text-high-emphasis">附件資料</div>
                <div v-if="typeof tbtca15Vo.otherZipFile=='string'&&tbtca15Vo.otherZipFile" class="d-flex justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon icon="tabler-paperclip"></v-icon>
                    <a class="ml-2" target="_blank"  @click.prevent="getJwtBeforeRedirect(tbtca15Vo.otherZipFile)" href=""    >附件資料</a>
                  </div>
                  <v-btn class="bg-white" color="black" variants="text" icon="tabler-x" @click="clearMultiple('otherZipFile')"></v-btn>
                </div>
                <VFileInput v-else multiple v-model="tbtca15Vo.otherFile" @change="handleOfficalFileMultiple('otherZipFile')" @click:clear="clearMultiple('otherZipFile')"/>
              </v-col>
          </v-row>
        </VCardText>
      </VCard>
    </v-col>
    <v-col cols="4">
      <v-card height="100%">
        <v-card-text>
          <v-row>
            <UserInfo
            :isShow="[true,true,true,true,false,false]"
            :application-number="tbtca15Vo.applyNo"
            :status="tbtca15Vo.status"
            :user-info="tbtca15Vo.applyEmpNo"
            issueDate=""
            documentNumber=""
            status-component="TrainingTeamApplication"
            />
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <!--  -->
  <v-form ref="reviewForm">
    <VCard class="mt-4" 
      v-if="viewParams.actionBtn && viewParams.actionBtn.action_approve">
      <VCardText>
        <v-row>
          <v-col cols="4">
            <div class="text-subtitle-2 text-high-emphasis">審查日期</div>
            <AppDateTimePicker
              v-model="tbtca18Vo.reviewDate"
              :rules="[rules.required]"
            />
          </v-col>
          <v-col cols="4">
            <div class="text-subtitle-2 text-high-emphasis">審查會議記錄</div>
            <VFileInput  v-model="viewParams.reviewFile" label="上傳會議記錄" 
            :rules="[rules.required]"
            @change="uploadFile"/>
          </v-col>
          <v-col cols="4">
            <div class="text-subtitle-2 text-high-emphasis">審查公文號</div>
            <v-text-field  v-model="tbtca18Vo.reviewDocNo" :rules="[rules.required]"></v-text-field>
          </v-col>
        </v-row>
      </VCardText>
      <VCardText>
        <v-row>
          <v-col cols="12">
            <AppTextarea label="審查意見" placeholder="輸入審查意見" v-model="tbtca18Vo.reviewComment" rows="2"></AppTextarea>
          </v-col>
        </v-row>
      </VCardText>
    </VCard> 
  </v-form>

  <VCard class="mt-4" v-if=" tbtca18Vos.length > 0">
    <VCardText>
      <v-row>
        <v-col cols="12">
          <v-data-table :items="tbtca18Vos" no-data-text="尚無資料" :headers="tbtca18VosHeaders" fixed-header height="200px" items-per-page="-1">
            <template v-slot:item.reviewFile="{ item }">
              <v-btn  v-if="item.reviewFile" :href="item.reviewFile">下載</v-btn>
            </template>
            <template v-slot:item.reviewMemberFile="{ item }">
              <v-btn  v-if="item.reviewMemberFile" :href="item.reviewMemberFile">下載</v-btn>
            </template>
            <template v-slot:item.status="{ item }">
              <Status 
                :status="item.status"
                :is-red="['Rejected', 'Revoke', 'Revoked', '駁回', '收回', '撤回']"
                :is-green="['Approved','Submitted','Passed']"
                :is-warning="['Draft','ReturnedForRevision']"
                shared-table-id="TrainingTeamApplication"
                btn-class="x-large"
                font-class="18px"
              />
            </template>
            <template v-slot:bottom> </template>
          </v-data-table>
        </v-col>
      </v-row>
    </VCardText>
  </VCard> 

  <VCard class="mt-4">
    <VCardTitle class="mt-4">
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <div class="ml-2 text-h5">
            培訓隊清單
          </div>
        </v-col>
        <v-col cols="2" v-if="!tbtca15Vo.status || tbtca15Vo.status === 'Draft'">
          <v-icon icon="tabler-file-download"></v-icon>
          <v-btn
            @click="sampleFile"
            color="primary"
            variant="text"
            class="pa-0"
            > 
            範例excel檔
          </v-btn>
        </v-col>
        <v-col cols="4" class="d-flex justify-end" >
          <VFileInput  v-model="viewParams.upExcelList" label="上傳清單" @change="parserExcel" />
          <VBtn class="ml-2" v-if="editTeamList()" icon="tabler-trash" variant="outlined" color="error" @click="deleteList"> 
          </VBtn>
          <VBtn class="ml-2" v-if="editTeamList()" icon="tabler-plus" variant="outlined" @click="tca16VoDlg.new()" > 
          </VBtn>
        </v-col>
      </v-row>

    </VCardTitle>
    <VCardText>
      <v-data-table :items="tbtca16Vos" :headers="tbtca16VosHeaders" fixed-header height="350px" 
      no-data-text="尚無資料"
        v-model="tableSelect.selected"
        item-value="memberId"
        return-object
        show-select items-per-page="-1">
        <template v-slot:item.actions="{ item }">
          <div v-if="editTeamList()">
            <IconBtn  @click="tca16VoDlg.edit(item)" >
            <VIcon icon="tabler-edit" color="primary" />
            <v-tooltip
              activator="parent"
              location="bottom"
            >編輯</v-tooltip>
          </IconBtn>
          </div>
        </template>
        <template v-slot:item.position="{ item }">
          {{getPositionName(item.position)}}
        </template>
        <template v-slot:item.review="{ item }">
          <div v-if="!tbtca15Vo.status || tbtca15Vo.status === 'Draft'">
            待審議
          </div>
          <div v-else>
            <input type="checkbox" 
              v-model="item.review"
              :true-value="'符合'"
              :false-value="null"
              :disabled="!(Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve && (tbtca15Vo.status === 'Passed'||tbtca15Vo.status === 'Resubmitted'))"
            >&nbsp; 符合
          </div>
        </template>
        <template v-slot:bottom> </template>
      </v-data-table>
    </VCardText>
  </VCard>



  <v-dialog v-model="tca16VoDlg.isShow" max-width="500" no-click-animation persistent :retain-focus="false">
    <v-card class="px-2">
      <v-form ref="tca16VoDlgFormRef">
        <v-col class="d-flex justify-center mt-5"
            ><h2 class="headline">新增培訓隊選手</h2></v-col
          >
        <v-row>
          <v-col cols="6" class="py-1">
            <v-card-title class="d-flex justify-space-between">
                <div >職稱<Required/></div>
                <div class="text-right text-caption" style="line-height:2">{{tca16VoDlg.vo.position?'職稱代碼:'+tca16VoDlg.vo.position:''}}</div>
              </v-card-title>
               <v-card-text>
                <v-autocomplete
                  v-model="tca16VoDlg.vo.position"
                  :items="positionData"
                  prepend-inner-icon="tabler-search"
                  :item-title="duPosition.pickerColumns[1]"
                  :item-value="duPosition.pickerColumns[0]"
                  no-data-text="查無資料"
                ></v-autocomplete>
               </v-card-text>
              <!-- <v-card-text>
                <v-text-field v-model="tca16VoDlg.vo.position"  :rules="[rules.required]"/>
              </v-card-text> -->
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span >姓名<Required/></span>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.name"  :rules="[rules.required]"/>
            </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
                <span >性別<Required/></span>
              </v-card-title>
              <v-card-text>
                <!-- <v-text-field v-model="tca16VoDlg.vo.gender"  :rules="[rules.required]"/> -->
                <v-select
                  :items="tca16VoDlg.gendersSelect"
                  v-model="tca16VoDlg.vo.gender"
                ></v-select>
              </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span >身分證<Required v-if="!isWorldPostNo()"/></span>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.id_number" :rules="[rules.twIdCheck]" @change="checkGender"/>
            </v-card-text>
          </v-col>
          <v-col cols="12" class="py-1">
            <v-card-title>
              <span >地址<Required/></span>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.address"  :rules="[rules.required]"/>
            </v-card-text>
          </v-col>
          <v-col cols="12" class="py-1">
            <v-card-title>
              <span >服務單位/就讀學校及年級</span>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.service_or_school"  />
            </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span >出生年月</span>
            </v-card-title>
            <v-card-text>
              <!-- <v-text-field v-model="tca16VoDlg.vo.birth_date"  :rules="[rules.required]"/> -->
              <AppDateTimePicker
                  v-model="tca16VoDlg.vo.birth_date"
                  placeholder="選擇日期"
                />
                <!-- <RocDatePicker :value="validDate" placeholder="請輸入" @value-change="(val) => change(val)"></RocDatePicker> -->
            </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span >項目/量級/位置</span>
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.event_or_position"  />
            </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span>符合培訓標準或遴選</span>
            </v-card-title>
              <v-card-text>
                <v-textarea v-model="tca16VoDlg.vo.eligibility" rows="2"></v-textarea>
            </v-card-text>
          </v-col>
          <v-col cols="6" class="py-1">
            <v-card-title>
              <span>資格</span>
            </v-card-title>
              <v-card-text>
              <v-text-field v-model="tca16VoDlg.vo.qualifications"  />
            </v-card-text>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="tca16VoDlg.isShow = false">取消</v-btn>
          <v-btn color="primary" text v-if="tca16VoDlg.isEdit" @click="tca16VoDlg.editOk()">儲存</v-btn>
          <v-btn color="primary" text v-if="tca16VoDlg.isNew" @click="tca16VoDlg.newOk()">新增</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</div>
</template>



<script setup lang="ts">
import { computed, reactive } from 'vue';
import Status from './StatusComponenet.vue'
import UserInfo from './UserInfoComponent.vue';
import Required from '../../../components/required.vue'
import duPosition from '../../../views/pickers/du/du-position-picker'
import { useSessionStorage } from '@vueuse/core';
import { isAssociationContact } from '@/utils/deUtil'
const route = useRoute()
const tca16VoDlgFormRef = ref(null);
const userDataCookie = useStorage('userData', {}).value
const submissionAsContact = useSessionStorage('SubmissionAsContact')
definePage({
  meta: {
    action: 'manage', //固定為 manage
      subject: 'TRAININGTEAM', //系統代碼(系統授權設定中的系統代碼)
  },
});
const reviewForm = ref(null)
const loadingBtn = ref(false)
const fileUrl = useStorage('drFsUrl').value
const tca16VoDlg = reactive({
  isShow: false,
  isEdit: false,
  isNew: false,
  orign: {},
  gendersSelect: ['男','女'],
  vo: {
    applyNo: '',
    position: '',
    name: '',
    gender: '男',
    id_number: '',
    birth_date: null,
    service_or_school: '',
    address: '',
    event_or_position: '',
    eligibility: '',
    qualifications: ''
  },
  edit: (tca16Vo:any) => {
    tca16VoDlg.orign = tca16Vo;
    tca16VoDlg.vo = Object.assign({}, tca16Vo);
    tca16VoDlg.isEdit= true;
    tca16VoDlg.isNew= false;
    tca16VoDlg.isShow= true;
  },
  editOk: async() => {
    if(await tca16VoDlg.validate()) {
      Object.assign(tca16VoDlg.orign, tca16VoDlg.vo);
      tca16VoDlg.isShow = false;
    } 
  },
  new: () => {
    for (var member in tca16VoDlg.vo) delete tca16VoDlg.vo[member];
    tca16VoDlg.vo.memberId = 'C'+currentMillisecond();
    tca16VoDlg.vo.gender = '男';
    tca16VoDlg.isEdit= false;
    tca16VoDlg.isNew= true;
    tca16VoDlg.isShow= true;
  },
  newOk: async() => {
    if(await tca16VoDlg.validate()) {
      tbtca16Vos.push( Object.assign({}, tca16VoDlg.vo));
      tca16VoDlg.isShow = false;
    } 
  },
  validate: async () => {
    const { valid } = await tca16VoDlgFormRef.value.validate();
    return valid
  }

});

const checkIdExpextList = ref([]);

const rules = ref({
  twIdCheck: (value: any) => {
    if(isWorldPostNo()){
      return true
    }
    if(!checktwId(value)) {
      return '身分證驗證失敗'
    } 
  },
  required: (value: any) => {
    if(Array.isArray(value)){
      return value.length>0 ||'此欄位為必填'
    }else{
      return !!value || '此欄位為必填'
    }
  },
});

const isWorldPostNo = () => {
  if(checkIdExpextList.value.length>0&&tca16VoDlg.vo.position&&checkIdExpextList.value.some(item=>item.value===tca16VoDlg.vo.position)){
    return true
  }
  return false
}

const viewParams = reactive({
  projectSelect: [],
  stageSelect:[],
  trainingPlanFileUrl: '',
  selectionFileUrl: '',
  upExcelList: [],
  reviewFile:[],
  actionBtn: {},
});

const tableSelect = reactive({
  selected: []
});

const tbtca15Vo = reactive({
    status:'Draft',
    projectId: '',
    stage: '',
    applyEmpNo: userDataCookie.userno,
    otherZipFile:'',
    otherFile:[],
    createEmpNo:userDataCookie.userno,
    deptNo:userDataCookie.depNo,
});

const tbtca16Vos = reactive([]);

const tbtca18Vo = reactive({
    applyNo: '',
    reviewDate  : '',
    reviewFile: '',
    reviewDocNo: ''
});

const tbtca18Vos = reactive([]);

const tbtca16VosHeaders = [
  { title: "操作", key: "actions", sortable: false },
  { title: '職稱', key: 'position', sortable: false },
  { title: '姓名', key: 'name', sortable: false },
  // { title: '身分證字號', key: 'id_number', sortable: false },
  { title: '出生年月', key: 'birth_date', sortable: false },
  { title: '服務單位/就讀學校及年級', key: 'service_or_school', sortable: false },
  { title: '地址', key: 'address', sortable: false },
  { title: '項目/量級/位置', key: 'event_or_position', sortable: false },
  { title: '符合培訓標準或遴選', key: 'eligibility', sortable: false },
  { title: '資格', key: 'qualifications', sortable: false },
  { title: '中心審核', key: 'review', sortable: false }
];

const tbtca18VosHeaders = [
  { title: '狀態', key: 'status', sortable: false },
  { title: '審核人員', key: 'serno', sortable: false },
  { title: '審議日期', key: 'reviewDate', sortable: false },
  { title: '會議記錄', key: 'reviewFile', sortable: false },
  { title: '公文號', key: 'reviewDocNo', sortable: false },
  { title: '審議意見', key: 'reviewComment', sortable: false },
  { title: '培訓隊清單', key: 'reviewMemberFile', sortable: false }
];

const editTeamList = () =>{
  if(tbtca15Vo.status=="Draft"){
    if(tbtca15Vo.deptNo!==userDataCookie.depNo){
      return false
    }
  }else if(tbtca15Vo.status === 'Approved'||tbtca15Vo.status === 'Training'||tbtca15Vo.status === 'Rejected'){
    return false
  }else if(tbtca15Vo.status=="ReturnedForRevision"){
    if(Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_start){
      return true
    }else{
      return false
    }
  }else{
    if(Object.keys(viewParams.actionBtn).length> 0 && viewParams.actionBtn.action_approve){
      return true
    }else{
      return false
    }
  }
  return true
}


const deleteList = async () => {
  const resultList = tbtca16Vos.filter(tbtca16Vo => {
    return !tableSelect.selected.some(select => select.memberId === tbtca16Vo.memberId)
  });
  tableSelect.selected = [];
  tbtca16Vos.length = 0;
  Object.assign(tbtca16Vos, resultList); 
};

const save = async () => {
  loadingBtn.value=true
  let tbtca15VoData ={...tbtca15Vo , otherFile:''}
  const apiUrl='/tca/trainingteam/save'
  await $api(apiUrl, {
    method: 'POST',
    body: {
      tbtca15Vo: tbtca15VoData,
      tbtca16Vos: tbtca16Vos
    }
  }).then((resp) => {
    if (resp.statusCode == 200) {
      popSwal('success','儲存成功');
      Object.assign(tbtca15Vo, resp.data.tbtca15Vo); 
      // tbtca16Vos.length = 0;
      // Object.assign(tbtca16Vos, resp.data.tbtca16Vos); 
      query(tbtca15Vo.applyNo,false);
    } else  {
      popSwal('error','送出失敗',resp.data);
    }
    loadingBtn.value=false
  })
};

const parserExcel = async () => {
  if (viewParams.upExcelList) {
    const formData = new FormData();

    formData.append('file',viewParams.upExcelList[0]);
    const apiUrl='/tca/trainingteam/uploadList'
    await $api(apiUrl, {
      method: 'POST',
      body: formData
    }).then((resp) => {
      if (resp.statusCode == 200) {
        tbtca16Vos.length = 0;
        Object.assign(tbtca16Vos, resp.data); 
        popSwal('success','上傳讀取檔案成功');
      } else  {
        popSwal('error','上傳讀取檔案失敗',resp.data);
      }
    })
  }
};

const deleteForm = async () => {
  $swal({
    title: `刪除資料`,
    text: `${tbtca15Vo.applyNo}`,
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      const formData = new FormData();
      formData.append('applyNo',tbtca15Vo.applyNo);
    
      const apiUrl='/tca/trainingteam/delete'
      await $api(apiUrl, {
        method: 'POST',
        body: formData
      }).then((resp) => {
      
        if (resp.statusCode == 200) {
          popSwal('success','刪除成功');
          for (var member in tbtca15Vo) delete tbtca15Vo[member];
          tbtca16Vos.length = 0;
          tbtca18Vos.length = 0;
        } else  {
          popSwal('error','刪除失敗',resp.data);
        }
      })
    }
  });
};

onMounted(async() => {
  getProjectSelect();
  let response = await fetchDeSelect({tabId: 'EXIDENTITY'});
  checkIdExpextList.value.splice(0,checkIdExpextList.value.length,...response);
  if(route.query.applyNo){
    query(route.query.applyNo,true);
  } 

  if(route.query.projectId){
    tbtca15Vo.projectId = route.query.projectId;
  } 
});

// project 下拉連動 stage 下拉
watch(() => tbtca15Vo.projectId , async (newValue) => {
  getStageSelect(newValue);
  getSelectionFile(newValue);
  getTrainingPlanFile(newValue);
});

const { data: getPositionData, execute: getPosition } = await useApi<any>(createUrl(duPosition.url, {
  query: {
    page: 0,
    size:1000,
    compId:'nstc',
  },
}))
const positionData = computed(()=>getPositionData.value.content)
const getProjectSelect = async () => {
  const apiUrl='/tca/trainingteam/get/project/select'
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    Object.assign(viewParams.projectSelect, resp.data); 
    viewParams.stageSelect = [];
    tbtca15Vo.stage = '';
  })
};

const getStageSelect = async (projectId) => {
  const apiUrl='/tca/trainingteam/get/stageSelect/'+projectId
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    // 轉換 第一階段：1，第二階段第一期：2.1 ，以此類推
    const regex = /(\d+)\.?(\d?)/;
    resp.data.forEach( (item) =>{
      let dispStage = '';
      let stage = item[0];
      const matches = stage.match(regex);
      if(matches) {
        let cNum = numberToChinese(matches[1]);
        dispStage = '第' + cNum + '階段';
        if(matches[2]) {
          cNum = numberToChinese(matches[2]);
          dispStage = dispStage + '第' + cNum +'期';
        }
      } else {
        dispStage = '建議參賽名單';
      }
      item[1] = dispStage + ' ' + item[1];
    });
    Object.assign(viewParams.stageSelect, resp.data); 
  })
};

const getSelectionFile = async (projectId) => {
  const apiUrl='/tca/trainingteam/get/selectionFile/'+projectId
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    viewParams.selectionFileUrl = resp.data; 
  })
};

const getTrainingPlanFile = async (projectId) => {
  const apiUrl='/tca/trainingteam/get/trainingPlanFile/'+projectId
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    viewParams.trainingPlanFileUrl = resp.data; 
  })
};

const query = async (queryApplyNo,popMsgFlag) => {
  const apiUrl='/tca/trainingteam/get/' + queryApplyNo
  await $api(apiUrl, {
    method: 'GET'
  }).then((resp) => {
    if (resp.statusCode == 200) {
      Object.assign(tbtca15Vo, resp.data.tbtca15Vo); 
      tbtca16Vos.length = 0;
      Object.assign(tbtca16Vos, resp.data.tbtca16Vos); 
      tbtca18Vos.length = 0;
      Object.assign(tbtca18Vos, resp.data.tbtca18Vos); 
      if(tbtca15Vo.formId) {
        getFormActions(tbtca15Vo.formId);
      }
      if(popMsgFlag){
        popSwal('success','查詢成功');
      }
    } else  {
      popSwal('error','查詢失敗',resp.data);
    }
  })
};

//送出
const submit= async () => {
  loadingBtn.value=true
  let tbtca15VoData ={...tbtca15Vo , otherFile:''}

  const apiUrl='/tca/trainingteam/submit'
  await $api(apiUrl, {
    method: 'POST',
    body: {
      tbtca15Vo: tbtca15VoData,
      tbtca16Vos: tbtca16Vos
    }
  }).then((resp) => {
    if (resp.statusCode == 200) {
      // Object.assign(tbtca15Vo, resp.data);
      query(tbtca15Vo.applyNo,false);
      popSwal('success','送出申請成功');
    } else  {
      popSwal('error','送出申請失敗',resp.data);
    }
    loadingBtn.value=false

  })
};

//收回
const withdraw= async () => {
  loadingBtn.value=true
  const formData = new FormData();
  formData.append('applyNo',tbtca15Vo.applyNo);

  const apiUrl='/tca/trainingteam/withdraw'
  await $api(apiUrl, {
    method: 'POST',
    body: formData
  }).then((resp) => {
    if (resp.statusCode == 200) {
      query(tbtca15Vo.applyNo,false);
      popSwal('success','申請收回成功');
    } else  {
      popSwal('error','申請收回失敗',resp.data);
    }
    loadingBtn.value=false
  })
};

//初審
const firstrev= async () => {
  loadingBtn.value=true
  tbtca18Vo.applyNo = tbtca15Vo.applyNo;

  const apiUrl='/tca/trainingteam/firstrev'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca18Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      query(tbtca15Vo.applyNo,false);
      popSwal('success','初審送出完成');
    } else  {
      popSwal('error','初審送出失敗',resp.data);
    }
    loadingBtn.value=false
  });
};

//備查
const approve= async () => {
  const { valid } = await reviewForm.value.validate();
  if(valid){
    loadingBtn.value=true
    tbtca18Vo.applyNo = tbtca15Vo.applyNo;
    const apiUrl='/tca/trainingteam/approve'
    await $api(apiUrl, {
      method: 'POST',
      body: tbtca18Vo
    }).then((resp) => {
      if (resp.statusCode == 200) {
        query(tbtca15Vo.applyNo,false);
        popSwal('success','備查送出完成');
      } else  {
        popSwal('error','備查送出失敗',resp.data);
      }
      loadingBtn.value=false
    });
  }
};

//回覆修正
const revise= async () => {
  // const { valid } = await reviewForm.value.validate();
  // if(valid){
    loadingBtn.value=true
    tbtca18Vo.applyNo = tbtca15Vo.applyNo;
    const apiUrl='/tca/trainingteam/revise'
    await $api(apiUrl, {
      method: 'POST',
      body: tbtca18Vo
    }).then((resp) => {
      if (resp.statusCode == 200) {
        query(tbtca15Vo.applyNo,false);
        popSwal('success','回覆修正送出完成');
      } else  {
        popSwal('error','回覆修正失敗',resp.data);
      }
      loadingBtn.value=false
    });
  // }
};

//駁回
const reject= async () => {
  $swal({
    title: `駁回資料`,
    text: `${tbtca15Vo.applyNo}`,
    showCancelButton: true,
    confirmButtonText: "我要駁回",
    cancelButtonText: "取消",
  }).then(async(result) => {
  /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      loadingBtn.value=true
      tbtca18Vo.applyNo = tbtca15Vo.applyNo;
      const apiUrl='/tca/trainingteam/reject'
      await $api(apiUrl, {
        method: 'POST',
        body: tbtca18Vo
      }).then((resp) => {
      
        if (resp.statusCode == 200) {
          query(tbtca15Vo.applyNo,false);
          popSwal('success','駁回送出完成');
        } else  {
          popSwal('error','駁回送出失敗',resp.data);
        }
        loadingBtn.value=false
      });
    }
  })
};

//已調訓
const training= async () => {
  loadingBtn.value=true
  const apiUrl='/tca/trainingteam/training'
  await $api(apiUrl, {
    method: 'POST',
    body: tbtca15Vo
  }).then((resp) => {
    if (resp.statusCode == 200) {
      query(tbtca15Vo.applyNo,false);
      popSwal('success','已調訓送出完成');
    } else  {
      popSwal('error','已調訓送出失敗',resp.data);
    }
    loadingBtn.value=false
  });
};


// 上傳審議文件
const uploadFile =async()=>{
  if (!viewParams.reviewFile) {
    return ;
  }
  const formData = new FormData();
  formData.append('file', viewParams.reviewFile[0]);
  try {
    const response = await $api(`/tca/file/upload`, {
      method: 'POST',
      body: formData,
    });
    tbtca18Vo.reviewFile = response.fileId
  } catch (error) {
    $swal({
      title: "上傳失敗",
      position: 'top-end',
      text: error.message || "請稍後再試",
      icon: "error"
    });
  }
}

// 取得可執行動作API
const getFormActions = async (formId) => {
  let apiUrl = '/form/getFormActions/' + formId;
  await $api(apiUrl, {
    method: 'GET',
  }).then((resp) => {
    if (resp && resp.actions) {
      Object.assign(viewParams.actionBtn, resp.actions.formActions);
    } else {
      console.error("Invalid response structure", resp);
    }
  }).catch((error) => {
    console.error("API request failed", error);
  });
};
const popSwal = (icon,title,text=null) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      showConfirmButton: false,
      text: text,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      showConfirmButton: false,
      // timer: 1500,
      text: text,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

function checktwId(id) {
  if(!id) {
    return;
  }
  id = id.trim();
    
  let verification = id.match("^[A-Z][12]\\d{8}$")
	if(!verification){
		return false
	}

  let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
  let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]

  id = String(conver.indexOf(id[0]) + 10) + id.slice(1);

  let checkSum = 0
  for (let i = 0; i < id.length; i++) {
      let c = parseInt(id[i])
      let w = weights[i]
      checkSum += c * w
  }

  return checkSum % 10 == 0
}


function currentMillisecond() {
  const now = new Date();

  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份從0開始，所以+1
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const   
 seconds = String(now.getSeconds()).padStart(2, '0');
  const milliseconds = String(now.getMilliseconds()).padStart(3, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}


function numberToChinese(num) {
  const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  let chineseNum = '';
  // 处理整数部分
  const integerPart = Math.floor(num);
  if (integerPart > 0) {
    const digits = integerPart.toString().split('').reverse();
    for (let i = 0; i < digits.length; i++) {
      if (digits[i] !== '0') {
        chineseNum = chineseDigits[digits[i]] +  chineseNum;
      } else {
        // 处理连续的零
        if (chineseNum.length > 0 && chineseNum[chineseNum.length - 1] !== '零') {
          chineseNum += '零';
        }
      }
    }
  }
  return chineseNum;
}
// JWT
const getJ = async()=>{
  const { data: jwt, execute: getJwt } = await useApi<any>(createUrl('/tca/file/get', {})) 
  return jwt
}

// file download
const getJwtBeforeRedirect = async (fileId) => {
  const jwt = await getJ();  // 获取新的 JWT
  let url = `${fileUrl}/api/v2/files/nstc/${fileId}?drJwt=${jwt.value}`;
  // 打开新链接
  window.open(url, '_blank');
};


const sampleFile= async () => {
  const apiUrl='/tca/trainingteam/sampleFile'
  await $api(apiUrl, {
    method: 'GET'
  }).then((response) => {
    var fileURL = window.URL.createObjectURL(new Blob([response]));
    var fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', '培訓隊申請-上傳清單範例.xlsx');
    document.body.appendChild(fileLink);
    fileLink.click();
  });
};
// 上傳文件-多檔
const uploadFileMultiple =async(files,val)=>{
  try {
    const response = await $api(`/tca/file/uploadFiles`, {
      method: 'POST',
      body: files,
    });
    tbtca15Vo[val] = response.zipIdd
    // console.log('File uploaded successfully', response.data);
  } catch (error) {
    $swal({
      title: "上傳失敗",
      position: 'top-end',
      text: error.message || "請稍後再試",
      icon: "error"
    });
  }
}

// 上傳文件-多檔
const handleOfficalFileMultiple = (val) => {
  let key = val.replace('Zip','')
  if (tbtca15Vo[key]) {
    // let arr =[]
    const formData = new FormData();
    tbtca15Vo[key].forEach((file, index) => {
      formData.append('multiFiles', file);
    });
    uploadFileMultiple(formData,val)
  }
};
// 清除file 及fileId
const clearMultiple =(fileName)=>{
  let key = fileName.replace('Zip','')
  tbtca15Vo[key]=[]
  tbtca15Vo[fileName]=''
}


// EXIDENTITY
const fetchDeSelect = async(query) => {
  try {
    const response = await $api(`/q/de/select/select/select/deSelect`, {
      method: 'GET',
      query
    });
    return response
  } catch (error) {
    console.error('取得簡易表格失敗:', error);
    return []
  }
}

// 從身分證判斷 性別
const checkGender =()=>{
  // console.log('checkGender')
  if(tca16VoDlg.vo.id_number&&tca16VoDlg.vo.id_number.length>1){
    let secondChar = tca16VoDlg.vo.id_number.charAt(1);
    if (secondChar == '1') {
      return tca16VoDlg.vo.gender=tca16VoDlg.gendersSelect[0]
    } else if (secondChar == '2') {
      return  tca16VoDlg.vo.gender=tca16VoDlg.gendersSelect[1];
    } 
  }
}

const changeProjectSelect = () => {
  tbtca15Vo.stage=''
}

const getPositionName =(positionCode)=>{
  const position = positionData.value.find((item)=>item[duPosition.pickerColumns[0]]==positionCode)
  return position?position[duPosition.pickerColumns[1]]:''
}
</script>

<style scoped>
/* Add any component-specific styles here */
.v-textarea textarea {
  min-height: 100px;
}

</style>
